import i18n from '@/i18n';
import { structures } from '@/utils/permission';
import { PREFIX } from '@/utils/constants';
const Layout = () => import('@/layouts/main.vue');
const Structures = () => import('./views/Index.vue');
const StructureView = () => import('./views/StructureView.vue');

export default [
  {
    path: 'structures',
    component: Layout,
    meta: { authRequired: true, header: true },
    children: [
      {
        path: '',
        name: `${PREFIX.INSPECTOR}.Structures`,
        component: Structures,
        meta: {
          title: i18n.global.t('structures.structures'),
          permission: { module: structures.module, key: structures.showAll },
        },
      },
      {
        path: 'view/:id?',
        name: `${PREFIX.INSPECTOR}.Structures.View`,
        component: StructureView,
        meta: {
          title: i18n.global.t('structures.view'),
          pageType: 'view',
          permission: { module: structures.module, key: structures.showOne },
        },
        props: true,
      },
      {
        path: 'create',
        name: `${PREFIX.INSPECTOR}.Structures.Create`,
        component: StructureView,
        meta: {
          title: i18n.global.t('structures.create'),
          pageType: 'create',
          permission: { module: structures.module, key: structures.create },
        },
      },
      {
        path: 'update/:id?',
        name: `${PREFIX.INSPECTOR}.Structures.Update`,
        meta: {
          title: i18n.global.t('structures.update'),
          pageType: 'update',
          permission: { module: structures.module, key: structures.update },
        },
        component: StructureView,
        props: true,
      },
    ],
  },
];
